import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { numberInputAnatomy, tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, extendTheme } from '@chakra-ui/react';
import { theme as defaultTheme } from '@chakra-ui/theme';
import { theme as StellaTheme } from '@cofit/components';
import '@fontsource/noto-sans-tc/400.css';
import '@fontsource/noto-sans-tc/500.css';
import '@fontsource/noto-sans-tc/700.css';
import 'focus-visible/dist/focus-visible';
import { Module } from 'src/types';
var cofitColor = 'rgba(0, 172, 200, 1)';
var clinicColor = '#eb901d';
var cofitScheme = {
  '50': '#EDFDFD',
  '100': '#C4F1F9',
  '200': '#9DECF9',
  '300': '#76E4F7',
  '400': '#0BC5EA',
  '500': cofitColor,
  '600': '#00A3C4',
  '700': '#0987A0',
  '800': '#086F83',
  '900': '#065666'
};
var clinicScheme = {
  '50': '#FFFAF0',
  '100': '#FEEBCB',
  '200': '#FBD38D',
  '300': '#F6AD55',
  '400': '#ED8936',
  '500': clinicColor,
  '600': 'rgb(223, 137, 28)',
  '700': '#BE6E2B',
  '800': '#915c1b',
  '900': '#652B19'
}; // 2. Extend the theme with new layer styles

var breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '960px',
  tb: '1024px',
  xl: '1200px',
  pc: '1440px',
  '2xl': '1536px',
  '3xl': '1920px'
};
var disabledButtonStyles = {
  background: 'gray.300',
  color: 'gray.600'
};
var disabledButtonOutlineStyles = {
  background: 'transparent',
  color: 'gray.600'
};

var _createMultiStyleConf = createMultiStyleConfigHelpers(tagAnatomy.keys),
    definePartsStyle = _createMultiStyleConf.definePartsStyle,
    defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;

var tagTheme = defineMultiStyleConfig({
  defaultProps: {
    colorScheme: 'brandScheme'
  },
  variants: {
    cofit: definePartsStyle({
      container: {
        px: '2',
        py: '1',
        bg: 'rgba(0, 172, 200, 0.24)',
        color: 'rgba(94, 88, 115, 1)',
        border: '1px solid rgba(0, 177, 201, 1)'
      }
    })
  }
});
var inputFieldStyle = {
  color: 'blackAlpha.300',
  _placeholder: {
    color: 'gray.400'
  },
  _disabled: {
    fontWeight: '400',
    color: 'gray.800',
    bgColor: 'gray.300',
    borderColor: 'gray.400',
    borderWidth: '1px'
  },
  _invalid: {
    borderColor: 'red.400',
    _focus: {
      borderColor: 'red.400',
      boxShadow: 'none',
      borderWidth: '2px'
    }
  }
};
var numberInputConfigHelper = createMultiStyleConfigHelpers(numberInputAnatomy.keys);
var NumberInput = numberInputConfigHelper.defineMultiStyleConfig({
  defaultProps: {
    variant: 'noStepper'
  },
  variants: {
    noStepper: function noStepper(props) {
      return numberInputConfigHelper.definePartsStyle({
        field: _objectSpread(_objectSpread(_objectSpread({}, defaultTheme.components.Input.variants.outline(props).field), inputFieldStyle), {}, {
          paddingEnd: 'var(--input-padding)'
        })
      });
    }
  }
});

var getConfig = function getConfig(_ref) {
  var brandScheme = _ref.brandScheme,
      brandColor = _ref.brandColor;
  return {
    sizes: {
      4.5: '1.125rem',
      7.5: '1.875rem',
      12.5: '3.375rem',
      25: '6.25rem',
      50: '12.5rem',
      54: '13.5rem',
      90: '22.5rem',
      94: '23.5rem'
    },
    styles: {
      global: function global() {
        return {
          // textStyle cannot override baseStyle, so use global p to set baseStyle
          // https://github.com/chakra-ui/chakra-ui/issues/6655
          p: {
            color: 'blackAlpha.300',
            fontSize: '16px',
            fontWeight: '400'
          },
          'a, a:link, a:visited, a:hover, a:active': {
            color: 'inherit',
            textDecoration: 'none'
          },
          '[aria-selected=true] p': {
            color: 'inherit'
          },
          '.react-viewer-toolbar': {
            zoom: 1.4
          },
          '.ReactTags__selected li': {
            listStyleType: 'none'
          },
          // minimize stacking context issues
          '.react-viewer-transition': {
            transition: 'opacity 0.01s ease-out !important'
          }
        };
      }
    },
    fonts: {
      heading: "'Noto Sans TC'",
      body: "'Noto Sans TC'"
    },
    layerStyles: {
      base: {
        bg: 'white',
        borderRadius: '6px',
        shadow: '0px 4px 24px rgba(0, 0, 0, 0.06);'
      },
      selected: {
        bg: 'teal.500',
        color: 'teal.700',
        borderColor: 'orange.500'
      },
      tableBorder: {
        borderRadius: '6px'
      }
    },
    colors: {
      orange: {
        '600': '#eb901d',
        brand: '#eb901d'
      },
      blackAlpha: {
        '300': '#5E5873'
      },
      gray: {
        '200': '#EBE9F1',
        '300': '#D1D4D9'
      },
      brand: brandColor,
      brandScheme: brandScheme,
      cofit: cofitColor,
      cofitScheme: cofitScheme,
      error: {
        text: '#822727',
        bg: 'rgb(244, 91, 91)'
      },
      warn: {
        text: '#d07400',
        bg: '#ffe1ba'
      },
      disabled: {
        text: '#1A202C',
        bg: '#EDF2F7'
      },
      success: {
        text: '#22543D',
        bg: 'rgb(72, 187, 120)'
      },
      statusBlue: {
        text: 'rgb(42, 67, 101)',
        bg: 'rgb(62, 140, 240)'
      },
      statusPink: {
        text: 'rgb(112, 36, 89)',
        bg: 'rgb(254, 215, 226)'
      },
      statusPurple: {
        text: 'rgb(68, 51, 122)',
        bg: 'rgb(233, 216, 253)'
      },
      statusGray: {
        text: 'rgb(26, 32, 44)',
        bg: '#b2c1d7'
      },
      statusWhite: {
        text: 'white',
        bg: 'white'
      }
    },
    textStyles: {
      caption: {
        fontSize: {
          xl: '16px',
          '2xl': '16px',
          '3xl': '20px'
        },
        fontWeight: '700',
        color: 'blackAlpha.300'
      },
      "default": {
        fontWeight: '600',
        color: '#6E6B7B',
        lineHeight: '1.5',
        letterSpaceing: '1px',
        fontSize: '16px',
        fonstStyle: 'normal'
      }
    },
    components: {
      Drawer: {
        variants: {
          aside: {
            // For not blocking all the page by the hidden drawer's content dialog container
            // https://github.com/chakra-ui/chakra-ui/issues/2893
            overlay: {
              pointerEvents: 'none',
              background: 'transparent'
            },
            dialogContainer: {
              pointerEvents: 'none',
              background: 'transparent'
            },
            dialog: {
              pointerEvents: 'auto'
            }
          }
        }
      },
      Tag: tagTheme,
      ReactPlayerWraper: {
        baseStyle: {
          '.react-player video': {
            maxHeight: '90vh'
          }
        }
      },
      ChatListItem: {
        variants: {
          grid: {
            h: 25,
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItem: 'center',
            position: 'relative',
            '&[data-active=true]': {
              background: 'rgba(0, 172, 200, 0.08)'
            },
            _hover: {
              background: '#F5F5F5',
              '[data-role=tag]': {
                display: 'none'
              },
              '[data-role=date]': {
                display: 'none'
              }
            },
            '[data-role=menu]': {
              position: 'absolute',
              top: 6,
              right: 4
            },
            '.chakra-avatar': {
              w: 10,
              h: 10,
              mr: 2
            },
            '[data-role=title]': {
              lineHeight: '1.4',
              fontSize: {
                base: 'sm',
                '2xl': '15px'
              },
              color: 'blackAlpha.300',
              wordBreak: 'break-all'
            },
            '[data-role=subTitle]': {
              mt: 0,
              p: 0,
              fontSize: 'sm',
              h: 5,
              color: '#A2A2A2',
              wordBreak: 'break-all'
            },
            '[data-role=date]': {
              align: 'right',
              color: '#5E5873',
              noOfLines: 1,
              mb: 1,
              fontSize: 'xs',
              h: 4.5
            },
            '[data-role=tag]': {
              color: 'white',
              bg: '#00A3C4',
              borderRadius: '3xl'
            },
            '[data-role=text]': {
              flex: 1
            },
            '[data-role=textNote]': {
              fontSize: 'xs',
              color: '#0930F9',
              p: 0,
              m: 0
            },
            '[data-role=note]': {
              w: 16
            }
          },
          flat: {
            h: 12.5,
            px: 3,
            display: 'flex',
            alignItem: 'center',
            '.chakra-avatar': {
              w: 7.5,
              h: 7.5,
              mr: 2
            },
            '[data-role=title]': {
              lineHeight: '1.4',
              fontSize: {
                base: 'sm',
                '2xl': '15px'
              },
              color: 'blackAlpha.300'
            },
            '[data-role=text]': {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            },
            '[data-role=date]': {
              w: 'full',
              textAlign: 'right',
              fontSize: 'sm',
              color: '#B9B9C3'
            },
            '[data-role=note]': {
              flex: 1,
              mt: 0,
              p: 0,
              align: 'right',
              justifyContent: 'center'
            }
          }
        },
        defaultProps: {
          variant: 'grid'
        }
      },
      Text: {
        baseStyle: {
          color: 'blackAlpha.300'
        }
      },
      Input: {
        defaultProps: {
          colorScheme: 'brandScheme'
        },
        variants: {
          outline: function outline(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Input.variants.outline(props)), {}, {
              field: _objectSpread(_objectSpread({}, defaultTheme.components.Input.variants.outline(props).field), inputFieldStyle)
            });
          },
          flushed: function flushed(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Input.variants.flushed(props)), {}, {
              field: _objectSpread(_objectSpread({}, defaultTheme.components.Input.variants.flushed(props).field), {}, {
                color: 'blackAlpha.300',
                _placeholder: {
                  color: 'gray.400'
                }
              })
            });
          }
        }
      },
      NumberInput: NumberInput,
      Textarea: {
        defaultProps: {
          colorScheme: 'brandScheme'
        },
        variants: {
          outline: function outline(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Textarea.variants.outline(props)), {}, {
              _placeholder: {
                color: 'gray.400'
              }
            });
          }
        }
      },
      Button: {
        defaultProps: {
          colorScheme: 'brandScheme'
        },
        baseStyle: _objectSpread(_objectSpread({}, defaultTheme.components.Button.baseStyle), {}, {
          fontWeight: 500,
          _focus: {
            boxShadow: 'none'
          },
          _hover: _objectSpread(_objectSpread({}, defaultTheme.components.Button.baseStyle._hover), {}, {
            _disabled: _objectSpread({}, disabledButtonStyles)
          }),
          _disabled: _objectSpread(_objectSpread(_objectSpread({}, defaultTheme.components.Button.baseStyle._disabled), disabledButtonStyles), {}, {
            _hover: _objectSpread({}, disabledButtonStyles)
          })
        }),
        variants: {
          outline: function outline(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Button.variants.outline(props)), {}, {
              _hover: {
                _disabled: _objectSpread({}, disabledButtonOutlineStyles)
              },
              _disabled: _objectSpread(_objectSpread({}, disabledButtonOutlineStyles), {}, {
                _hover: _objectSpread({}, disabledButtonOutlineStyles)
              })
            });
          }
        }
      },
      Tooltip: {
        baseStyle: {
          bgColor: 'blackAlpha.300',
          color: 'white',
          px: 4,
          py: 2,
          rounded: 'md',
          align: 'start'
        }
      },
      Checkbox: {
        defaultProps: {
          colorScheme: 'brandScheme'
        },
        baseStyle: function baseStyle(props) {
          return {
            control: _objectSpread(_objectSpread({}, defaultTheme.components.Checkbox.baseStyle(props)), {}, {
              bg: 'white',
              borderColor: '#D8D6DE'
            })
          };
        }
      },
      Radio: {
        defaultProps: {
          colorScheme: 'brandScheme'
        },
        baseStyle: function baseStyle(props) {
          return {
            label: _objectSpread(_objectSpread({}, defaultTheme.components.Radio.baseStyle(props)), {}, {
              color: 'blackAlpha.300'
            })
          };
        }
      },
      Tabs: {
        defaultProps: {
          colorScheme: 'brandScheme'
        },
        baseStyle: _objectSpread(_objectSpread({}, StellaTheme.components.Tabs.baseStyle), {}, {
          tab: {
            _focus: {
              boxShadow: 'none'
            }
          }
        }),
        variants: _objectSpread(_objectSpread({}, StellaTheme.components.Tabs.variants), {}, {
          colorful: function colorful(props) {
            var c = props.colorScheme; // extract colorScheme from component props

            return {
              tab: {
                h: '42px',
                color: 'white',
                borderTopRadius: '3xl',
                _selected: {
                  bg: 'gray.50',
                  color: 'gray.700',
                  fontWeight: 600
                }
              },
              tablist: {
                h: '55px',
                pt: 3.5,
                color: 'white',
                bg: "".concat(c, ".600")
              }
            };
          },
          chat: function chat(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Tabs.variants.line(props)), {}, {
              tablist: _objectSpread(_objectSpread({}, defaultTheme.components.Tabs.variants.line(props).tablist), {}, {
                w: 'full'
              }),
              tab: _objectSpread(_objectSpread({}, defaultTheme.components.Tabs.variants.line(props).tab), {}, {
                fontSize: 'md',
                color: 'blackAlpha.300',
                _selected: _objectSpread(_objectSpread({}, defaultTheme.components.Tabs.variants.line(props).tab._selected), {}, {
                  fontWeight: 600
                }),
                _focus: {
                  outline: 'none',
                  boxShadow: 'none'
                }
              }),
              tabpanel: {
                p: 0
              }
            });
          }
        })
      },
      Table: {
        variants: {
          simple: function simple(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Table.variants.simple(props)), {}, {
              tr: {
                borderColor: 'gray.300',
                borderBottomWidth: 1,
                borderTopWidth: 0,
                _hover: {
                  bgColor: 'rgba(0, 172, 200, 0.04)'
                }
              },
              td: _objectSpread(_objectSpread({}, defaultTheme.components.Table.variants.simple(props).td), {}, {
                fontSize: '16px',
                px: '5px',
                py: '8px',
                color: 'blackAlpha.300',
                lineHeight: '1.5',
                fontWeight: '400',
                borderWidth: 0
              })
            });
          },
          medicine: function medicine(props) {
            return _objectSpread(_objectSpread({}, defaultTheme.components.Table.variants.simple(props)), {}, {
              thead: {
                position: 'sticky',
                top: '-1px',
                overflow: 'hidden',
                bgColor: 'gray.200'
              },
              th: _objectSpread(_objectSpread({}, defaultTheme.components.Table.variants.simple(props).th), {}, {
                fontSize: '16px',
                lineHeight: '1.5',
                flexDirection: 'row',
                borderBottomWidth: 1,
                borderRightWidth: 1,
                borderRightColor: 'white',
                borderBottomColor: 'gray.300',
                px: '5px',
                py: '8px',
                fontWeight: '400',
                color: 'blackAlpha.300',
                whiteSpace: 'nowrap',
                bgColor: 'gray.200',
                _last: {
                  borderRightWidth: 0
                },
                '& p:not(a p)': {
                  color: 'inherit'
                }
              }),
              td: {
                fontSize: '16px',
                px: '5px',
                py: '6px',
                color: 'blackAlpha.300',
                lineHeight: '1.5',
                borderRightWidth: 1,
                borderRightColor: 'gray.100',
                fontWeight: '400',
                _last: {
                  borderRightWidth: 0
                },
                '& p:not(a p)': {
                  color: 'inherit'
                }
              },
              tr: {
                borderColor: 'gray.300',
                borderBottomWidth: 1,
                bgColor: 'white',
                _hover: {
                  bgColor: 'rgba(254, 250, 244, 1)'
                },
                _last: {
                  borderBottomWidth: 0
                }
              }
            });
          }
        }
      },
      Menu: {
        variants: {
          chat: {
            button: {
              w: 6,
              h: 6,
              p: 1,
              bg: '#5E5873',
              color: 'white',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            },
            list: {
              minWidth: 'none',
              p: 0,
              bg: '#5E5873',
              borderRadius: 'md',
              overflow: 'hidden'
            },
            menu: {
              position: 'relative'
            },
            item: {
              h: 7,
              color: 'white',
              bg: '#5E5873',
              _hover: {
                bg: '#5E5873'
              },
              _focus: {
                bg: '#5E5873'
              }
            }
          }
        }
      },
      Stepper: {
        baseStyle: {
          title: {
            color: 'blackAlpha.300'
          },
          indicator: {
            '&[data-status=active]': {
              borderWidth: 0,
              bg: 'orange.brand',
              color: 'white'
            },
            '&[data-status=complete]': {
              bg: 'green.400',
              color: 'white'
            },
            '&[data-status=incomplete]': {
              borderWidth: 0,
              bg: 'gray.300',
              color: 'white'
            }
          },
          separator: {
            bg: 'gray.300',
            '&[data-status=complete]': {
              bg: 'gray.300'
            }
          }
        }
      },
      Stat: {
        baseStyle: {
          label: {
            color: 'blackAlpha.300'
          },
          number: {
            color: 'blackAlpha.300'
          }
        }
      },
      Popover: {
        baseStyle: {
          popper: {
            zIndex: 100
          }
        }
      }
    },
    breakpoints: breakpoints
  };
};

export var getTheme = function getTheme(_ref2) {
  var moduleType = _ref2.moduleType;
  var brandScheme = moduleType === Module.consult ? cofitScheme : clinicScheme;
  var brandColor = moduleType === Module.consult ? cofitColor : clinicColor;
  var theme = extendTheme(getConfig({
    brandScheme: brandScheme,
    brandColor: brandColor
  }));
  return theme;
};